/** Indica payload de error de hardware del lector. */
export function isPassportHardwareErrorPayload(value: unknown): boolean {
  return (
    typeof value === 'object' &&
    value !== null &&
    'passportHardwareError' in value &&
    (value as { passportHardwareError?: boolean }).passportHardwareError === true
  );
}
